import { useEffect, useRef } from 'react';

const useRefocus = <T extends HTMLElement = HTMLDivElement>(
  dependency: unknown
) => {
  const ref = useRef<T>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Intentional Additional Dependency
  useEffect(() => {
    if (ref.current) {
      ref?.current.focus();
    }
  }, [dependency]);

  return ref;
};

export default useRefocus;
